import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-servicios-telmex',
  templateUrl: './servicios-telmex.component.html',
  styleUrls: ['./servicios-telmex.component.css']
})
export class ServiciosTelmexComponent implements OnInit {

  constructor(private router:Router) { }

  ngOnInit() {
  }

  fnNavegar(pagina){
    if(pagina=="PRIV")
      this.router.navigate(['privacidad']);
  }

}
